(() => {
    const section = document.querySelector('[data-wpbook]');
    if (!section) return;

    const form = section.querySelector('[data-wpbook-product-form]');
    const submitButton = form?.querySelector('button[type="submit"]');
    const stickyButton = section.querySelector('[data-wpbook-sticky-add]');
    const scrollButton = section.querySelector('[data-wpbook-scroll-buy]');
    const mobileBar = section.querySelector('[data-wpbook-mobile-bar]');

    const addProduct = async (event) => {
      event.preventDefault();
      if (!form || !submitButton || submitButton.disabled) return;

      const variantId = Number(
        form.querySelector('input[name="id"]')?.value
      );

      if (!variantId) return;

      const originalLabel = submitButton.innerHTML;
      submitButton.disabled = true;
      submitButton.textContent = 'Dodaję do koszyka…';

      if (stickyButton) {
        stickyButton.disabled = true;
        stickyButton.textContent = 'Dodaję…';
      }

      try {
        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1
                }
              ]
            })
          }
        );

        if (!response.ok) {
          throw new Error('Nie udało się dodać produktu.');
        }

        window.location.assign(section.dataset.cartUrl || '/cart');
      } catch (error) {
        submitButton.disabled = false;
        submitButton.innerHTML = originalLabel;

        if (stickyButton) {
          stickyButton.disabled = false;
          stickyButton.innerHTML =
            'Kupuję <span aria-hidden="true">→</span>';
        }

        window.alert(
          'Nie udało się dodać książki. Odśwież stronę i spróbuj ponownie.'
        );
      }
    };

    form?.addEventListener('submit', addProduct);

    stickyButton?.addEventListener('click', () => {
      form?.requestSubmit();
    });

    scrollButton?.addEventListener('click', () => {
      form?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    });

    if (
      mobileBar &&
      submitButton &&
      'IntersectionObserver' in window
    ) {
      const buttonObserver = new IntersectionObserver(
        ([entry]) => {
          mobileBar.classList.toggle(
            'is-visible',
            !entry.isIntersecting
          );
        },
        {
          threshold: 0.2
        }
      );

      buttonObserver.observe(submitButton);
    } else {
      mobileBar?.classList.add('is-visible');
    }

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.querySelector('[data-wpbook]')) {
        document.body.classList.remove('wpbook-page');
      }
    });
  })();
